var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customsd"},[_c('iframe',{attrs:{"id":"frame_content","width":"100%","src":_vm.href,"frameborder":"0","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }